import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ReactSVG } from "react-svg";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { useIntl } from 'react-intl';
import messages from './messages';

import { useTheme } from '@mui/material/styles';
import { Box, Button, Typography, Modal, Tabs, Tab, IconButton, Checkbox, Popover, MenuItem, Select, Tooltip } from '@mui/material';
import { IconSvg } from '../../../utils/globalIcons';
import moment from 'moment';
import { getStyles } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { setExtractionDocumentTypesState, setExtractionTasksState } from '../../../Redux/slice/dataSlice';
import LoadBar from '../../../utils/LoadBar';
import { Close, CloudUpload, Refresh } from '@mui/icons-material';
import { extractionFileSave, getAllExtractionDocumentTypes } from '../../../utils/ApiFunctions/ExtractionData';
import { tostAlert } from '../../../utils/AlertToast';
import { getComponentsStyles } from '../../../styles/componentsStyles';
import getExtractionTasksData from '../../../utils/ApiFunctions/ExtractionTasksData';

import FilesApi from '../../../Api/Services/AppflyteBackend/FileServiceApi';
import { fetchSubscriberId, fetchSubscriptionId, fetchThirdPartyToken, fetchThirdPartyTokenProvider } from '../../../utils/GetAccountDetails';
import axios from 'axios';
import { apiErrorHandler } from '../../../utils/ApiErrorHandler';
import { useAppContext } from '../../../context/AppContext';
import PaginationTable from '../../../components/PaginationTable';
import { getMainStyles } from '../../../styles/styles';
import { useCheckCredit } from '../../../utils';
import ExtractionTraining from '../../../components/ExtractionTraining';
import handleFileUpload from '../../../utils/fileUpload';
import { ANALYTICS_S3_BUCKET_FOLDER, ANALYTICS_S3_BUCKET_SCRIPT_FILE } from '../../../utils/constants';

let s3_folder_name = ANALYTICS_S3_BUCKET_FOLDER
let s3_file_name = ANALYTICS_S3_BUCKET_SCRIPT_FILE
let bucket_name = window.__ENV__.S3_BUCKET_NAME;

function ExtractionDocuments() {
    const theme = useTheme();
    const styles = getStyles(theme);
    const componentsStyles = getComponentsStyles(theme);
    const mainStyles = getMainStyles(theme);
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { selectedOrganization, selectedProject, reviewStatus, setReviewStatus } = useAppContext();
    const isOutOfCredits = useCheckCredit();
    const intl = useIntl();

    const [loading, setLoading] = useState(false);
    const [daataLoading, setDataLoading] = useState(false);

    const [tabValue, setTabValue] = useState('all_tasks');
    const [donwnloadAnchorEl, setDownloadAnchorEl] = useState(null);

    const [selectedDocumentType, setSelectedDocumentType] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [modalStatus, setModalStatus] = useState(false);
    const [fileId, setFileId] = useState(null);
    const [previewMode, setPreviewMode] = useState("document");

    const [documentTypes, setDocumentTypes] = useState([]);
    const [extractionTasks, setExtractionTasks] = useState([]);
    const [failedExtractionTasks, setFailedExtractionTasks] = useState([]);
    const [processedExtractionTasks, setProccessedExtractionTasks] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [chatbotData, setChatbotData] = useState({ chatbotStatus: false, chatbotUrl: null, chatBotType: null });

    const [lastKey, setLastKey] = useState(null);
    const [hasMore, setHasMore] = useState(true);

    const extraction_document_types = useSelector(state => state.all_data.extraction_document_types)
    const extraction_tasks = useSelector(state => state.all_data.extraction_tasks)

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    useEffect(() => {
        if (reviewStatus !== true) {
            getAllData("load")
        }
        //eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (reviewStatus === true) {
            setReviewStatus(false)
            handleReload()
        }
        //eslint-disable-next-line
    }, [reviewStatus])

    const updateTaskData = async (documentTypesData = [], extractionTaskData = []) => {
        try {
            const documentTypeMap = Object.fromEntries(
                documentTypesData.map(f => [
                    f?.payload?.__auto_id__,
                    { name: f?.payload?.name }
                ])
            );

            const merged_data = extractionTaskData.map(task => {
                const document_type_id = task?.payload?.document_type_id;
                const documentTypeInfo = documentTypeMap[document_type_id]?.name || null;

                return {
                    ...task,
                    payload: {
                        ...task.payload,
                        document_type_name: documentTypeInfo
                    }
                };
            });

            const { failed_tasks, processed_tasks } = merged_data.reduce(
                (acc, item) => {
                    if (item?.payload?.failure) {
                        acc.failed_tasks.push(item);
                    } else {
                        acc.processed_tasks.push(item);
                    }
                    return acc;
                },
                { failed_tasks: [], processed_tasks: [] }
            );

            return {
                merged_data,
                failed_tasks,
                processed_tasks
            };

        } catch (error) {
            console.error(error);
            return {
                merged_data: [],
                failed_tasks: [],
                processed_tasks: []
            };
        }
    };

    const getAllData = async (load_status) => {
        setLoading(true);
        try {
            const [documentTypeResponse, extractionTaskResponse] = await Promise.all([
                getDocumentTypes(),
                getAllExtractionTasks(load_status)
            ]);
            if (extractionTaskResponse) {
                const updated_response = await updateTaskData(documentTypeResponse || [], extractionTaskResponse)
                setExtractionTasks(updated_response.merged_data);
                setFailedExtractionTasks(updated_response.failed_tasks);
                setProccessedExtractionTasks(updated_response.processed_tasks);
                dispatch(setExtractionTasksState(updated_response.merged_data))
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const getAllExtractionTasks = async (load_status) => {
        try {
            if ((extraction_tasks || []).length > 0 && load_status === "load") {
                return extraction_tasks;
            } else {
                let currentKey = null;
                while (true) {

                    const project_id = selectedProject?.payload?.__auto_id__;
                    const response = await getExtractionTasksData(currentKey, project_id);
                    const responseData = response?.data ?? [];
                    const lastEvaluatedKey = response?.lastEvaluatedKey ?? null;

                    if (responseData.length > 0) {
                        setLastKey(lastEvaluatedKey);
                        setHasMore(!!lastEvaluatedKey);
                        return responseData;
                    } else if (lastEvaluatedKey) {
                        currentKey = lastEvaluatedKey;
                        continue;
                    } else {
                        setHasMore(false);
                        return [];
                    }
                }
            }
        } catch (error) {
            console.log(error);
            return []
        }
    }

    const getDocumentTypes = async () => {
        try {
            let doc_type = []
            if (extraction_document_types?.length > 0) {
                doc_type = extraction_document_types
            } else {
                const project_id = selectedProject?.payload?.__auto_id__
                const response = await getAllExtractionDocumentTypes(project_id);
                dispatch(setExtractionDocumentTypesState(response))
                doc_type = response
            }
            setDocumentTypes(doc_type)
            return doc_type;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    const onFetchNextPage = async () => {
        if (hasMore) {
            setLoading(true);
            try {

                const project_id = selectedProject?.payload?.__auto_id__;
                const response = await getExtractionTasksData(lastKey, project_id);
                const newData = response?.data ?? [];
                const lastEvaluatedKey = response?.lastEvaluatedKey ?? null;

                const updated_response = await updateTaskData(documentTypes, newData)

                setExtractionTasks(prev => [...prev, ...updated_response.merged_data]);
                setFailedExtractionTasks(prev => [...prev, ...updated_response.failed_tasks]);
                setProccessedExtractionTasks(prev => [...prev, ...updated_response.processed_tasks]);
                dispatch(setExtractionTasksState([...extraction_tasks, ...updated_response.merged_data]));

                setLastKey(lastEvaluatedKey);
                if (!lastEvaluatedKey) setHasMore(false);

            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        }
    };

    const handleReload = async () => {
        setExtractionTasks([]);
        setFailedExtractionTasks([]);
        setProccessedExtractionTasks([]);
        setLastKey(null);
        setHasMore(true);
        await getAllData("reload");
    };

    // Extraction Training Page Setup
    const handleModalOpen = async () => {
        if (isOutOfCredits) {
            tostAlert('Your credits have run out. Please top up account to continue.', 'error')
            return
        }
        setModalStatus(true);
        setSelectedDocumentType(null)
    };

    const handleModalClose = () => {
        setModalStatus(false);
        setSelectedFiles([])
    };

    const handleFileDrop = async (event) => {
        try {
            event.preventDefault();
            event.stopPropagation();
            const files = Array.from(event.dataTransfer.files);
            event.target.value = null;
            setSelectedFiles(files);
        } catch (error) {
            console.log(error)
        }
    };

    const handleFileChange = async (event) => {
        try {
            event.preventDefault();
            event.stopPropagation();
            const files = Array.from(event.target.files);
            event.target.value = null;
            setSelectedFiles(files);
        } catch (error) {
            console.log(error)
        }
    };

    const handleFileRemove = (index) => {
        const updatedFiles = [...selectedFiles];
        updatedFiles.splice(index, 1);
        setSelectedFiles(updatedFiles);
    }

    const handleUploadTrain = async () => {

        if (!selectedDocumentType) {
            tostAlert(intl.formatMessage(messages.document_selection_check), 'warning')
            return
        }

        setDataLoading(true);
        try {
            if (selectedFiles?.length === 0) {
                tostAlert(intl.formatMessage(messages.file_selection_error), 'warning')
                return
            }

            const file_name = selectedFiles[0]?.name ?? "file";
            const upload_response = await handleFileUpload(file_name, selectedFiles[0])
            if (upload_response.status === 200) {
                const doc_type_id = selectedDocumentType?.payload?.__auto_id__;
                const save_response = await extractionFileSave(upload_response.fileName, upload_response.fileUrl, upload_response.fileId, doc_type_id);
                if (save_response.status === 200) {
                    if (save_response.status === 200) {
                        const fileResponseData = save_response?.data?.id ?? null;
                        handleModalClose()
                        setFileId(fileResponseData)
                        setSelectedFiles([])
                        setPreviewMode("train")
                    }
                }
            }

        } catch (error) {
            console.log(error)
        } finally {
            setDataLoading(false);
        }
    }

    // Task File Downloading
    const handleClose = () => {
        setDownloadAnchorEl(null);
    };

    const handleDownloadFiles = async () => {
        setDataLoading(true)
        try {
            if ((selectedRows || []).length === 0) {
                tostAlert(intl.formatMessage(messages.file_selection_error), 'warning');
                return;
            }
            handleClose();

            if (selectedRows.length > 1) {

                const zipName = window.prompt("Enter ZIP file name", "files") || "files";
                const zip = new JSZip();

                for (const row of selectedRows) {

                    const originalUrl = row.file_path;
                    if (!originalUrl) continue;

                    const cleanUrl = originalUrl.split('?')[0];
                    const fileName = row.file_name || 'file';

                    try {
                        const response = await fetch(cleanUrl);
                        if (!response.ok) throw new Error(`Failed to fetch ${cleanUrl}`);
                        const blob = await response.blob();
                        zip.file(fileName, blob);
                    } catch (err) {
                        console.warn(`Skipping file: ${fileName}`, err);
                    }
                }

                const zipBlob = await zip.generateAsync({ type: 'blob' });
                saveAs(zipBlob, `${zipName}.zip`);
            }
            else {
                const row = selectedRows?.at(-1);
                const originalUrl = row.file_path;
                const cleanUrl = originalUrl?.split('?')[0];
                const fileName = row.file_name || 'file';

                if (!cleanUrl) {
                    tostAlert(intl.formatMessage(messages.invalid_file_url), 'error');
                    return;
                }

                const response = await fetch(cleanUrl);
                if (!response.ok) throw new Error('File fetch failed');
                const blob = await response.blob();
                saveAs(blob, fileName);
            }
        } catch (error) {
            console.error('Download failed:', error);
            tostAlert('Download failed', 'error');
        } finally {
            setDataLoading(false)
        }
    };

    const handleDownloadJSON = async () => {
        setDataLoading(true)
        try {

            if ((selectedRows || [])?.length === 0) {
                tostAlert(intl.formatMessage(messages.file_selection_error), 'warning');
                return
            }

            handleClose();

            const subscriber_id = await fetchSubscriberId();
            const subscription_id = await fetchSubscriptionId();
            const organization_id = selectedOrganization?.payload?.__auto_id__ ?? null;
            const project_id = selectedProject?.payload?.__auto_id__ ?? null;

            const file_path = selectedRows.map(item => `ameya-extraction/subscriber/${subscriber_id}/subscription_id/${subscription_id}/organization_id/${organization_id}/project_id/${project_id}/extracted/${item?.file_id}.json`);

            const object_paths = file_path.join(',');
            const response = await FilesApi.getDownloadUrl(bucket_name, object_paths);

            if (response.status === 200) {

                const responseData = response.data ?? [];

                if (responseData.length === 1) {
                    const [filePath, fileUrl] = Object.entries(responseData[0])[0];
                    const fileName = filePath.split("/").pop();

                    const resp = await axios.get(fileUrl);
                    const jsonString = JSON.stringify(resp.data, null, 2);

                    const blob = new Blob([jsonString], { type: "application/json" });
                    saveAs(blob, fileName);
                    return;
                }

                const zipName = window.prompt("Enter ZIP file name", "files") || "files";
                const zip = new JSZip();

                await Promise.all(
                    responseData.map(async (item) => {
                        const [filePath, fileUrl] = Object.entries(item)[0];
                        const fileName = filePath.split("/").pop();

                        const resp = await axios.get(fileUrl);
                        const jsonString = JSON.stringify(resp.data, null, 2);

                        zip.file(fileName, jsonString);
                    })
                );

                const zipBlob = await zip.generateAsync({ type: "blob" });
                saveAs(zipBlob, `${zipName}.zip`);

            } else {
                tostAlert(intl.formatMessage(messages.download_error), 'error')
                console.error('Failed to get download URLs:', response.statusText);
            }
        } catch (error) {
            apiErrorHandler(error)
            console.error('Download failed:', error);
        } finally {
            setDataLoading(false)
        }
    };

    const handleRowSelect = (newRow) => {
        setSelectedRows((prev) => {
            const exists = prev.some(r => r.__auto_id__ === newRow.__auto_id__);
            return exists
                ? prev.filter(r => r.__auto_id__ !== newRow.__auto_id__)
                : [...prev, newRow];
        });
    };

    // Data Column Operations
    useEffect(() => {
        setSelectedRows([])
    }, [tabValue])

    const handleRowClick = (row) => {
        const review_status = (row?.payload?.approval_status === "APPROVED" || row?.payload?.approval_status === "PENDING") && row?.payload?.failure === false;
        if (review_status) {
            navigate(`/all-documents/${row?.payload?.file_name}`, {
                state: {
                    file_id: row?.payload?.file_id,
                    file_path: row?.payload?.file_path,
                    file_name: row?.payload?.file_name,
                    task_id: row?.payload?.__auto_id__,
                    approval_status: row?.payload?.approval_status
                }
            })
        }
    };

    const checkStatus = {
        PENDING: { bg_color: "#0B51C5", label: 'Review' },
        APPROVED: { bg_color: "#17803D", label: 'Approved' },
    };

    const checkExtarctionStatus = {
        SUCCESS: 'Processed',
        PROCESSING: 'Processing',
        FAILED: 'Failed'
    };

    const columns = [
        {
            id: 'checkbox',
            label: "",
            sortable: false,
            renderCell: (row) => (
                <Checkbox
                    sx={{ ...componentsStyles.checkbox }}
                    checked={selectedRows.some(r => r.__auto_id__ === row?.payload?.__auto_id__)}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => {
                        e.stopPropagation();
                        handleRowSelect(row?.payload);
                    }}
                />
            ),
        },
        {
            id: 'payload.file_name',
            label: 'Name',
            sortable: true,
            renderCell: (row) => row?.payload?.file_name || "Unknown"
        },
        {
            id: 'payload.status',
            label: 'Extraction Status',
            sortable: true,
            filter: true,
            renderCell: (row) =>
                <Box display={'flex'} alignItems={'center'}>
                    <span style={{ marginRight: '10px' }}>
                        <ReactSVG
                            src={{
                                SUCCESS: IconSvg.trainedIcon,
                                PROCESSING: IconSvg.trainingIcon,
                                FAILED: IconSvg.errorIcon
                            }[row?.payload?.status] || IconSvg.errorIcon}
                            beforeInjection={(svg) => {
                                svg.setAttribute('style', 'width:24px; height:24px; display:block;');
                            }}
                        />
                    </span>
                    <Typography sx={styles.paraText}>{checkExtarctionStatus[row?.payload?.status || 'Unknown']}</Typography>
                </Box>
        },
        {
            id: 'payload.approval_status',
            label: 'Review Status',
            sortable: true,
            filter: true,
            renderCell: (row) => (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {(row?.payload?.failure === false &&
                        (row?.payload?.approval_status === "APPROVED" || row?.payload?.approval_status === "PENDING"))
                        ?
                        (<Button
                            sx={{
                                ...styles.reviewBtn,
                                border: `1px solid ${checkStatus[row?.payload.approval_status]?.bg_color}`
                            }}
                        >
                            <Typography sx={{ ...styles.paraText, color: `${checkStatus[row?.payload.approval_status]?.bg_color}` }}>
                                {checkStatus[row?.payload.approval_status]?.label}
                            </Typography>
                        </Button>)
                        :
                        (<Typography sx={styles.paraText}>-</Typography>)
                    }
                </Box >
            )
        },
        {
            id: 'payload.document_type_name',
            label: 'Document Type',
            sortable: true,
            filter: true,
            renderCell: (row) => row?.payload?.document_type_name
        },
        {
            id: 'payload.uploaded_via',
            label: 'Uploaded via',
            sortable: true,
            renderCell: (row) => row?.payload?.uploaded_via || "Direct Upload"
        },
        {
            id: 'payload.started_at',
            label: 'Date added',
            sortable: true,
            renderCell: (row) => {
                const dateStr = row?.payload?.started_at;
                const cleanStr = dateStr?.substring(0, 16);
                return moment(cleanStr, 'YYYY-MM-DD HH:mm').format('DD-MMM-YYYY hh:mm A');
            }
        }
    ];

    // Load Chatbot and launch chatbot
    useEffect(() => {
        const getChatBot = async () => {
            const subscriber_id = await fetchSubscriberId()
            const subscription_id = await fetchSubscriptionId()
            const analytics_app_id = selectedProject?.payload?.analytics_app_id ?? null;
            const analytics_project_id = selectedProject?.payload?.analytics_project_id ?? null;
            const check_url = `${s3_folder_name}/${s3_file_name}/${subscriber_id}/${subscription_id}/${analytics_project_id}/${analytics_app_id}.js`;
            checkAnalyticsChatbot(check_url)
        }
        getChatBot()
        //eslint-disable-next-line
    }, [])

    const checkAnalyticsChatbot = async (check_url) => {
        const response = await FilesApi.getDownloadUrl(bucket_name, check_url);
        if (response?.status !== 200) {
            return
        }

        const logo_res_data = response?.data?.at(-1) ?? null;
        const download_url = Object.values(logo_res_data ?? {})?.at(-1) ?? null;

        if (!download_url) {
            return
        }

        try {
            const response = await fetch(download_url, { method: 'GET' });
            const scriptText = await response.text();
            const configMatch = scriptText.match(/const\s+chatbotConfig\s*=\s*(\{[\s\S]*?\})\s*;?\s*\/\/\s*END\s+chatbotConfig/);
            if (configMatch && configMatch[1]) {
                const chatbotConfig = JSON.parse(configMatch[1]) ?? {};
                const app_bot_type = chatbotConfig?.APP_DETAILS?.app_bot_type ?? '';
                setChatbotData(prev => ({
                    ...prev,
                    chatbotStatus: true,
                    chatbotUrl: download_url,
                    chatBotType: app_bot_type
                }))

            }
            return
        } catch {
            return
        }
    };

    useEffect(() => {
        if (!chatbotData?.chatbotStatus || !chatbotData?.chatbotUrl) return;

        const scriptId = "extraction-chatbot-script";
        const existing = document.getElementById(scriptId);
        if (existing) existing.remove();

        const script = document.createElement("script");
        script.id = scriptId;
        script.src = chatbotData.chatbotUrl;
        script.async = true;
        document.body.appendChild(script);

        return () => {
            console.log("Cleanup — removing chatbot iframe + globals");

            try {
                window.AmeayaChatBot?.("destroy");
                if (window.AmeayaChatBot) delete window.AmeayaChatBot;
            } catch { }

            ["ameya-simple-chatbot-iframe", "ameya-chatbot-iframe"].forEach(id => {
                const iframe = document.getElementById(id);
                if (iframe) iframe.remove();
            });

            if (window.toggleChatbot) delete window.toggleChatbot;

            const oldScript = document.getElementById(scriptId);
            if (oldScript) oldScript.remove();
        };
    }, [chatbotData, location.pathname]);

    const handleLaunch = async () => {

        const third_party_token = await fetchThirdPartyToken();
        const token_provider = await fetchThirdPartyTokenProvider()

        const params = {
            token_provider: token_provider,
            third_party_token: third_party_token
        };

        if (window.toggleChatbot) {
            window.toggleChatbot(params);
        } else {
            console.warn("Chatbot script not loaded yet");
        }

    };

    return (
        <Box sx={styles.mainContainer}>

            {(previewMode === "train" && selectedDocumentType && fileId) ?
                (<ExtractionTraining
                    document_type_id={selectedDocumentType?.payload?.__auto_id__}
                    document_type={selectedDocumentType?.payload?.master_document_type}
                    file_id={fileId}
                    setPreviewMode={setPreviewMode}
                />)
                :
                (<Box sx={styles.cardContainer}>

                    {daataLoading && <LoadBar />}

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography sx={{ fontSize: '16px', fontWeight: '600' }}>All Documents</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Button
                                onClick={(e) => setDownloadAnchorEl(e.currentTarget)}
                                sx={{ backgroundColor: '#000000', borderRadius: '20px', width: '120px' }}
                            >
                                <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#FFFFFF' }}>
                                    DOWNLOAD
                                </Typography>
                            </Button>
                            <Button
                                onClick={handleModalOpen}
                                sx={{ backgroundColor: '#0B51C5', borderRadius: '20px', width: '90px' }}>
                                <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#FFFFFF' }}>
                                    UPLOAD
                                </Typography>
                            </Button>
                        </Box>
                    </Box>

                    <Box sx={{ width: '100%', marginTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'inline-block', borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={tabValue} onChange={handleTabChange} aria-label="basic tabs example">
                                <Tab
                                    value="all_tasks"
                                    label={<Typography sx={{ fontSize: '16px', fontWeight: 600, textTransform: 'none' }}
                                    >
                                        All Files
                                    </Typography>} />
                                <Tab
                                    value="processed_tasks"
                                    label={<Typography sx={{ fontSize: '16px', fontWeight: 600, textTransform: 'none' }}
                                    >
                                        Processed
                                    </Typography>} />
                                <Tab
                                    value="failed_tasks"
                                    label={<Typography sx={{ fontSize: '16px', fontWeight: 600, textTransform: 'none' }}
                                    >
                                        Errors
                                    </Typography>} />
                            </Tabs>
                        </Box>

                        {!loading &&
                            <Tooltip
                                title="Reload"
                                arrow
                                placement="bottom"
                            >
                                <IconButton onClick={handleReload}>
                                    <Refresh />
                                </IconButton>
                            </Tooltip>
                        }

                    </Box>

                    <Box marginTop={'30px'} paddingBottom={'20px'}>
                        <PaginationTable
                            data={tabValue === 'all_tasks' ? extractionTasks : tabValue === "processed_tasks" ? processedExtractionTasks : failedExtractionTasks}
                            columns={columns}
                            loading={loading}
                            onFetchNextPage={onFetchNextPage}
                            hasMore={hasMore}
                            onRowClick={handleRowClick}
                        />
                    </Box>

                </Box>)
            }

            {(chatbotData.chatbotStatus && chatbotData.chatBotType === "advanced_bot" && chatbotData.chatbotUrl) && <Box sx={{ position: "fixed", bottom: 24, right: 24, zIndex: 1000 }}>
                <Button
                    id="chatBotButton"
                    variant="contained"
                    sx={styles.chatbotBtn}
                    onClick={handleLaunch}
                >
                    💬
                </Button>
            </Box>}

            <Popover
                open={Boolean(donwnloadAnchorEl)}
                anchorEl={donwnloadAnchorEl}
                onClose={() => setDownloadAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                sx={{ borderRadius: '5px' }}
            >
                <Box p={1} minWidth={200}>
                    <MenuItem
                        onClick={handleDownloadFiles}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <ReactSVG src={IconSvg.filesIcon} beforeInjection={(svg) => {
                                svg.setAttribute('style', 'width: 18x; height: 18px;display: block;');
                                const paths = svg.querySelectorAll('path');
                                paths.forEach((path) => {
                                    path.setAttribute('stroke', '#000000');
                                });
                            }} />
                            <Typography sx={{ fontSize: '14px', fontWeight: '400', marginLeft: '10px' }}>Original File</Typography>
                        </Box>
                    </MenuItem>
                    <MenuItem
                        onClick={handleDownloadJSON}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <ReactSVG src={IconSvg.jsonViewIcon} beforeInjection={(svg) => {
                                svg.setAttribute('style', 'width: 18px; height: 18px; display: block;');
                                const paths = svg.querySelectorAll('path');
                                paths.forEach((path) => {
                                    path.setAttribute('stroke', '#000000');
                                });
                            }} />
                            <Typography sx={{ fontSize: '14px', fontWeight: '400', marginLeft: '10px' }}>Download JSON</Typography>
                        </Box>
                    </MenuItem>
                </Box>
            </Popover>

            <Modal open={modalStatus} onClose={handleModalClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={mainStyles.modalcontainer}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography sx={{ fontSize: '16px', fontWeight: '600' }}>Upload File and Train</Typography>
                        <IconButton onClick={handleModalClose}>
                            <Close />
                        </IconButton>
                    </Box>
                    <Box marginTop={'15px'}>
                        <Typography sx={{ fontSize: '14px', fontWeight: '600', marginBottom: '5px' }}>Select Document Type</Typography>
                        <Select
                            variant="outlined"
                            size='small'
                            sx={{ width: '100%' }}
                            value={selectedDocumentType}
                            onChange={(e) => setSelectedDocumentType(e.target.value)}
                            displayEmpty
                            renderValue={(selected) => selected ? selected?.payload?.name : "Select DocumentType"}
                        >
                            <MenuItem value="" disabled>
                                <Typography variant="body1">Select Document Type</Typography>
                            </MenuItem>
                            {documentTypes.length > 0 ? (
                                documentTypes.map((item, index) => (
                                    <MenuItem key={index} value={item}>
                                        <Typography variant="body1">{item?.payload?.name}</Typography>
                                    </MenuItem>
                                ))
                            ) : (
                                <MenuItem value="" disabled>
                                    <Typography variant="body1">No Document Type Available</Typography>
                                </MenuItem>
                            )}
                        </Select>
                    </Box>
                    <Box sx={{
                        marginTop: '20px',
                        padding: '20px',
                        textAlign: 'center',
                        cursor: 'pointer',
                        backgroundColor: '#F3F5F7',
                        borderRadius: '20px',
                    }}>
                        <Box
                            onDrop={handleFileDrop}
                            onDragOver={(e) => e.preventDefault()}
                        >
                            <input
                                type="file"
                                accept=".pdf,.docx,.xlsx,.png,.jpg,.jpeg"
                                onChange={handleFileChange}
                                style={{ display: 'none', cursor: 'pointer' }}
                                id="fileInput"
                            />
                            <label
                                id='fileInput'
                                htmlFor="fileInput">
                                {selectedFiles.length === 0 &&
                                    <Box>
                                        <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>Drag and drop files or&nbsp;<span style={{ color: '#0B51C5', cursor: 'pointer' }}>click to upload</span> </Typography>
                                        <Typography sx={styles.paraText}>
                                            <p><strong>Accepted file formats:</strong> PDF, Word, Excel, PNG, JPG, JPEG</p>
                                        </Typography>
                                    </Box>
                                }
                                <IconButton component="span">
                                    <CloudUpload style={{ color: "black", width: "32px", height: "32px" }} />
                                </IconButton>
                            </label>
                        </Box>
                        <Box display={'flex'} justifyContent={'center'} alignItems={'center'} flexWrap="wrap" >
                            {
                                selectedFiles.length > 0 && selectedFiles.map((file, index) => (
                                    < Box key={index} display={'flex'} justifyContent={'center'} alignItems={'center'} alignContent={'center'} textAlign={'center'} padding={'3px 15px 3px 15px'} margin={'5px'} backgroundColor={'#FFFFFF'} borderRadius={'20px'}>
                                        <Typography sx={styles.paraText}>{file.name}</Typography>
                                        <Box marginLeft={'10px'} onClick={() => handleFileRemove(index)}>
                                            <ReactSVG src={IconSvg.deleteIcon} className='delete_icon' />
                                        </Box>
                                    </Box>
                                ))
                            }
                        </Box>
                    </Box>
                    <Box sx={{ marginTop: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Button
                            onClick={handleUploadTrain}
                            disabled={loading}
                            sx={styles.uploadBtn}>
                            <Typography sx={styles.btnText}>Upload and Train</Typography>
                        </Button>
                    </Box>
                </Box>
            </Modal>

        </Box>
    )
}

export default ExtractionDocuments;